export default function Dashboard({ points, setPage }) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-b from-blue-400 via-red-400 to-red-600 p-6">
      <h1 className="text-3xl font-bold text-white mb-8">Dashboard</h1>

      <div className="bg-white p-6 rounded-3xl shadow-lg w-full max-w-md text-center">
        <h2 className="text-xl font-bold text-red-600 mb-4">
          แต้มสะสมของคุณ: {points}
        </h2>

        <button
          onClick={() => setPage("upload")}
          className="w-full bg-blue-500 hover:bg-blue-600 text-white py-3 rounded-2xl font-semibold mb-4 transition"
        >
          อัพโหลดรูปเพิ่ม
        </button>

        <button
          onClick={() => setPage("rewards")}
          className="w-full bg-red-500 hover:bg-red-600 text-white py-3 rounded-2xl font-semibold transition"
        >
          แลกของรางวัล
        </button>
      </div>
    </div>
  );
}
